<div class="control-panel-root" *transloco="let t">
  <app-header>{{t('control-panel')}}</app-header>
  <div class="panels-line-1">
    <app-administrators-panel class="panel-item"></app-administrators-panel>
    
  </div>
  <div class="panels-line-2">
    <app-family-container class="panel-item"></app-family-container>
    <app-products-container class="panel-item"></app-products-container>
  </div>
</div>
